function setGeneral(state, payload) {
    state.general = payload;
}

export default {
    setGeneral
}
  